// _app/immutable/assets/13.7ea1ae3f.css
export default ".flex-list.svelte-1co2f7o{display:flex;flex-wrap:wrap;gap:30px;justify-content:space-around;align-items:center;list-style-image:url(../../../svg/send.svg)}\n";